import React, { useContext, useState } from 'react';
import Graph from '../../components/graph/Graph';
import Floatbar from '../../components/floatbar/Floatbar';
import "./Home.css";
import AuthContext from '../../contexts/AuthContext';
import { useGraph } from '../../contexts/GraphContext';
import { FaTools } from "react-icons/fa"; // Import tool icon

export function Home() {
    const { user } = useContext(AuthContext); // Get the user from AuthContext
    const graphData = useGraph();
    const { trackName } = graphData;

    const [showTools, setShowTools] = useState(false); // State for toggling tools

    return (
        <>
            <Graph />

            {/* Tool Icon (Visible on Mobile) */}
            <button className="tool-icon" onClick={() => setShowTools(!showTools)}>
                <FaTools/>
            </button>

            {/* Sidebar-like Floating Tools */}
            <div className={`top-right-docker ${showTools ? 'show' : 'hide'}`}>
                <Floatbar showSearchbar={true} showProgressTracker={!!user && trackName && trackName !== ''} />
            </div>
        </>
    );
}
